export default "__VITE_ASSET__BGb2GvHI__"